"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceRepository = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const Config_1 = require("../../Config");
const CrudRepository_1 = require("../CrudRepository");
const SpaceKnockingMemberRepository_1 = require("./SpaceKnockingMemberRepository");
const SpaceMemberRepository_1 = require("./SpaceMemberRepository");
class SpaceRepository extends CrudRepository_1.CrudRepository {
    constructor(env) {
        super(env || Config_1.Build5Env.PROD, interfaces_1.PublicCollections.SPACE);
        this.getTopByMember = (member, orderBy = ['createdOn'], orderByDir = ['desc'], startAfter, limit) => {
            const spaceMember = this.memberRepo.getTopBySubColIdLive(member, orderBy, orderByDir, startAfter, limit);
            return spaceMember.pipe((0, rxjs_1.switchMap)(async (members) => {
                const promises = members.map((member) => this.getById(member.parentId));
                return (await Promise.all(promises)).map((s) => s);
            }));
        };
        this.getPendingSpacesByMemberLive = (member, orderBy = ['createdOn'], orderByDir = ['desc'], startAfter, limit) => {
            const spaceMember = this.knockingMemberRepo.getTopBySubColIdLive(member, orderBy, orderByDir, startAfter, limit);
            return spaceMember.pipe((0, rxjs_1.switchMap)(async (members) => {
                const promises = members.map((member) => this.getById(member.parentId));
                return (await Promise.all(promises)).map((s) => s);
            }));
        };
        this.memberRepo = new SpaceMemberRepository_1.SpaceMemberRepository(env);
        this.knockingMemberRepo = new SpaceKnockingMemberRepository_1.SpaceKnockingMemberRepository(env);
    }
}
exports.SpaceRepository = SpaceRepository;
